module.exports = __webpack_public_path__ + "static/desktop_logo-d58012a3536730b2ca841b3d8276a53a.png";